<template>
  <section class="license-card">
    <div class="header-section">
      <div class="title-wrapper">
        <h2>{{ title }}</h2>
      </div>
      <a
        class="download-icon"
        @click="baixarCarteira(data.protocoloFormatado)"
        title="Baixar Licença"
        v-if="data.status === 'Vigente'"
      >
        <img src="@/assets/download.svg" alt="Download" />
      </a>
    </div>
    <el-row>
      <el-col :span="12">
        <LicenseAttribute label="Status:" :value="statusBadge" />
        <LicenseAttribute label="Número:" :value="data.numero" />
        <LicenseAttribute label="Modalidade:" :value="data.modalidade" />
        <LicenseAttribute label="Nome:" :value="nomeTitular" />
        <LicenseAttribute
          label="CPF/Passaporte:"
          :value="documentoTitularFormatado"
        />
      </el-col>
      <el-col :span="12">
        <LicenseAttribute label="Validade:" :value="data.validade" />
        <LicenseAttribute label="Emissão:" :value="data.emissao" />
        <LicenseAttribute label="Limite de captura:" :value="data.limite" />
        <LicenseAttribute
          label="Alerta"
          v-if="data.mensagemAvisoCarteira"
          :value="data.mensagemAvisoCarteira"
          valueClass="text-warning"
        ></LicenseAttribute>
      </el-col>
    </el-row>
    <div class="footer-section">
      <div class="div-qr-code">
        <img
          class="qr-code"
          :src="'data:image/png;base64,' + data.qrCode"
          alt="QR Code"
        />
      </div>
      <IpaamLogo />
    </div>
  </section>
</template>

<script>
import ApiService2 from "../../services/shared/ApiService2";
import StatusBadge from "../shared/StatusBadge.vue";
import IpaamLogo from "../shared/IpaamLogo.vue";

export default {
  props: ["data"],
  components: {
    LicenseAttribute: {
      props: ["label", "value", "valueClass"],
      render(h) {
        return h("div", [
          h("p", [h("strong", this.label)]),
          h("div", { class: this.valueClass }, [this.value || "--"])
        ]);
      }
    },
    StatusBadge,
    IpaamLogo
  },
  computed: {
    title() {
      return `Licença de Pescador ${this.data.modalidade}`;
    },
    nomeTitular() {
      return this.data.nome || "--";
    },
    documentoTitularFormatado() {
      return this.data.cpfPassaporte || "--";
    },
    statusBadge() {
      return this.$createElement(StatusBadge, {
        props: { status: this.data.status }
      });
    }
  },
  methods: {
    baixarCarteira(protocolo) {
      const protocoloDesformatado = protocolo
        .replace(/\//g, "")
        .replace(/-/g, "");

      ApiService2.downloadGet(
        "/api/public/carteira",
        { protocolo: protocoloDesformatado },
        "carteira-licenca-pesca.pdf",
        true
      ).catch(() => {});
    }
  }
};
</script>

<style>
.license-card p {
  font-size: 12px !important;
  margin-bottom: 3px;
}

.text-warning {
  color: #f03e3e !important;
  font-weight: 800;
}
</style>

<style scoped>
.license-card {
  position: relative;
  padding: 1rem;
  border-radius: 10px;
  background: #f4f4f4;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 12px;
  color: #383838;
}

.header-section {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.2rem;
  margin-bottom: 0.5rem;
  position: relative;
}

.title-wrapper {
  flex: 0 1 95%;
  display: flex;
  align-items: center;
}

.title-wrapper h2 {
  margin: 0;
  color: #444;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 100%;
  word-break: break-word;
}

.header-section .download-icon {
  flex: 1 1 5%;
  align-self: flex-start;
  margin-top: 0;
  margin-left: 8px;
  position: static;
}

.license-card h2 {
  color: #444;
  margin-top: 4px;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.el-col div {
  margin-bottom: 10px;
}

.el-col div div {
  margin-bottom: 5px;
}

.footer-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.qr-code {
  width: 150px;
}

.download-icon {
  font-size: 1.2rem;
  text-decoration: none;
  color: #000;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.6rem;
  background-color: transparent;
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}
.download-icon:hover {
  color: #fff;
  background-color: #fff;
}
.download-icon span {
  font-size: 0.9rem;
  font-weight: bold;
}

@media (max-width: 768px) {
  .footer-section .div-qr-code img {
    width: 100%;
  }
  .footer-section .div-qr-code,
  .footer-section .ipaam-logo {
    display: flex;
    flex: 1;
  }
}
</style>
